'use strict';

angular.module('mobile-apps')

	.directive('userMention', [function(){
		return {
			require: ['ngModel', 'uiMention'],
			scope: {
				ngModel: "=",
				users: "="
			},
			link: function(scope, elem, attrs, _ref) {
				var _ref2 = _slicedToArray(_ref, 2);

				var ngModel = _ref2[0];
				var uiMention = _ref2[1];


				/**
				 * Defines how the choice should be displayed for the users
				 */
				uiMention.label = function(choice) {
					if (!choice) {
						return '';
					}
					return choice.displayName;
				};


				/**
				 * Defines which choices to display for the user and moves
				 * the user-select-dropdown to the cursor position
				 */
				uiMention.findChoices = function(match, mentions) {
					// Get the position of the cursor via the textarea-helper
					// but remove it again directly because with it added
					// the user-selection does not work anymore.
					var pos = elem.textareaHelper('caretPos');
					elem.textareaHelper('destroy');

					// Move the user-select-dropdown to the cursor position.
					if (pos && pos.hasOwnProperty('top') && pos.hasOwnProperty('left')) {
						var dropdown = $('.ui-mention-dropdown');
						dropdown.css('top', parseInt(pos.top));
						dropdown.css('left', parseInt(pos.left)+5);
					}

					var userInput = match[1].toLowerCase();

					return scope.users
						// Remove items that are already mentioned because double
						// mentions mess everything up.
						.filter(function (choice) {
							return !mentions.some(function (mention) {
								return mention.id === choice.id;
							});
						})
						// Matches items from search query
						.filter(function (choice) {
							return ~(choice.checkName.toLowerCase()).indexOf(userInput);
						});
				};


				/**
				 * Overwrite default function to add support for special people
				 * with special characters in their name
				 */
				uiMention.decode = function () {
					var value = arguments.length <= 0 || arguments[0] === undefined ? ngModel.$modelValue : arguments[0];
					return value ? value.replace(/@\[([\s\w\x7f-\xff]+):[0-9a-z-]+\]/gi, '$1') : '';
				};


				// Update the display data till we got all the data we need
				var unwatchUsers = scope.$watch('users', function(newValue) {
					if(newValue){
						updateDisplay();
					}
				}, true);
				var unwatchNgModel = scope.$watch('ngModel', function(newValue) {
					if(newValue){
						updateDisplay();
					}
				}, true);


				/**
				 * Update the display data to highlight any mentioned users
				 */
				function updateDisplay() {
					if (scope.users.length === 0) {
						// If there are no users that can be mentioned no
						// need for check for any in the string
						return;
					} else if (!scope.ngModel) {
						// If there is no value for the model yet wait till we
						// have some
						return;
					}

					// We seem to have the data we need so we can remove the
					// watchers
					unwatchUsers();
					unwatchNgModel();

					// Look if any users are mentioned
					var mentions = scope.ngModel.match(/@\[([\s\w\x7f-\xff]+):[0-9a-z-]+\]/gi);
					if (mentions) {
						// If users are mentioned get their user-ids
						var userIds = [];
						mentions.forEach(function(mention) {
							var match = mention.match(/:([0-9a-z]+)\]/);
							if (match && match.length > 1) {
								userIds.push(match[1]);
							}
						});

						if (userIds.length === 0) {
							// If for some reason no user-id could be found no
							// need to go on
							return;
						}

						// Go through all the users which can be mentioned and
						// add the ones which are already mentioned to the list
						var mentionedUsers = [];
						scope.users.forEach(function(userData) {
							if (userIds.indexOf(userData.id) !== -1) {
								mentionedUsers.push( userData );
							}
						});
						uiMention.mentions.push.apply(uiMention.mentions, mentionedUsers);

						// Render the view so that the mentioned users get
						// highlighted
						uiMention.render(scope.ngModel);

						// Get the display string without the special
						// user-mention-syntax and display it like that in
						// text field
						var decodedString = uiMention.decode();
						ngModel.$setViewValue(decodedString);
						ngModel.$render();
					}
				}


				// Add support for tab-key to choose currently selected user
				elem.on('keydown', function(event) {
					if (event.keyCode === 9) {
						event.preventDefault();
						uiMention.select();
					}
				});

			}
		};
	}]);
